import { c as commonjsGlobal } from '../../_virtual/commonjsHelpers.js';

var $BigInt = commonjsGlobal.BigInt;

var hasBigints = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

export { hasBigints as h };
